import * as React from 'react';

/**
 * Lists' view line (SR-412), below 1366 px where the header has no room for it: the view picker,
 * *Save view ▾*, which says when the screen differs from the view, and a private view's own
 * "Saving…" / "Saved". From 1366 px the same pieces sit in the header. The view is Lists' "where I
 * am": its filter, columns, sort, grouping, colours and page size are the view's (work-pages design,
 * "Lists"). *Save data* and *Discard* are the toolbar's, before *Actions ▾*.
 */
export function ListViewBar({
  picker,
  mark,
  saveView,
  scope
}: {
  picker: React.ReactNode;
  /** Said after the picker in place of *Changed — not saved* — a private view's own save. */
  mark?: React.ReactNode;
  saveView?: React.ReactNode;
  /** Teams' *Team path*, a scope the view saves. */
  scope?: React.ReactNode;
}) {
  return (
    <div role="group" aria-label="View" data-view-bar="" className="flex flex-wrap items-center gap-2 text-[0.8125rem]">
      {picker}
      {saveView}
      {mark}
      {scope}
    </div>
  );
}
